const pendingKey = uid => `apcs:ticket-redemption:${uid || 'signed-out'}`;
export const totalTickets = quantities => Object.values(quantities || {}).reduce((sum, quantity) => sum + quantity, 0);
export const ticketLabel = tier => ({ orchestra: 'Orchestra tickets', performers: 'Performer places',
    presto: 'Presto', allegro: 'Allegro', lento: 'Lento' }[tier] || tier);
export const sessionLabel = session => session
    ? `${session.venueName || session.venue} · ${session.date} · ${session.time}` : 'Awaiting assignment';

export function readPendingClaim(storage, uid) {
    try {
        const value = JSON.parse(storage.getItem(pendingKey(uid)) || 'null');
        return value?.eventId && value?.bookingId && value?.requestId && ['redeem', 'undo'].includes(value.action) ? value : null;
    } catch (error) { return null; }
}
export function savePendingClaim(storage, uid, claim) {
    if (claim) storage.setItem(pendingKey(uid), JSON.stringify(claim));
    else storage.removeItem(pendingKey(uid));
}
export function createClaimRequest(eventId, bookingId, allowance, quantities, correction) {
    const randomId = typeof window !== 'undefined' ? window.crypto?.randomUUID?.() : null;
    return { eventId, bookingId, channel: allowance.channel, expectedRevision: allowance.revision,
        sessionKey: allowance.sessionKey,
        requestId: randomId || `${Date.now()}-${Math.random().toString(36).slice(2)}`,
        ...(correction ? { action: 'undo', targetClaimId: correction.id, reason: correction.reason.trim() }
            : { action: 'redeem', quantities: { ...quantities } }) };
}
